import axios from 'axios'

import { API_ENDPOINTS } from '@/constants/apiEndpoints'

class MaintenanceAccidentsQueries {
    fetchAccidents(args = {}) {
        if (typeof args === 'string') {
            const queryString = args
            const url = `/accidents/accidents${queryString ? `?${queryString}` : ''}`
            return axios.get(url)
        }

        const { paginate = '', query = '' } = args
        return axios.get(`/accidents/accidents${paginate}${query}`)
    }

    fetchAccident(accidentId) {
        return axios.get(`/accidents/accidents/${accidentId}`)
    }

    fetchUnsolvedMachineAccidents(machineId) {
        return axios.get(`${API_ENDPOINTS.MAINTENANCE.ACCIDENTS.REVIEW}?isSolved=false&machine=${machineId}`)
    }

    fetchAccidentTypes() {
        return axios.get('/accidents/accidents/dicts/types')
    }

    fetchAccidentStatuses() {
        return axios.get('/accidents/accidents/dicts/statuses')
    }

    fetchAccidentStatusHistory(accidentId) {
        return axios.get(`/accidents/accidents/${accidentId}/status-history`)
    }

    fetchMachinesBasicData() {
        return axios.get('/accidents/accidents/dicts/machines')
    }

    fetchSoftwareTypes() {
        return axios.get('/accidents/accidents/dicts/software-types')
    }

    fetchAccidentDepartments() {
        return axios.get('/accidents/accidents/dicts/departments')
    }

    fetchAccidentUserDepartments() {
        return axios.get('/accidents/accidents/dicts/departments-filter')
    }

    createAccident(payload) {
        return axios.post('/accidents/accidents', payload, {
            timeout: 0
        })
    }

    updateAccident(accidentData) {
        return axios.put(`/accidents/accidents/${accidentData.id}`, accidentData, {
            timeout: 0
        })
    }

    deleteAccident(accidentId) {
        return axios.delete(`/accidents/accidents/${accidentId}`)
    }

    createAccidentComment(payload) {
        return axios.post('/accidents/accident-comments', payload)
    }

    generateAccidentsReport({ query = '' } = {}) {
        return axios.get(`/accidents/accidents?report=true${query}`, {
            timeout: 120000
        })
    }

    fetchAccidentDashboard({ query = '' } = {}) {
        const queryString = query ? `?${query}` : ''
        return axios.get(`/accidents/accidents/dashboard${queryString}`)
    }

    generateAccidentDashboardReport({ query = '' } = {}) {
        const queryString = query ? `&${query}` : ''
        return axios.get(`/accidents/accidents/dashboard?report=true${queryString}`, {
            timeout: 120000
        })
    }

    fetchAccidentDashboardMachines({ query = '' } = {}) {
        const queryString = query ? `?${query}` : ''
        return axios.get(`/accidents/accidents/dashboard/dicts/machines${queryString}`)
    }
}

export default new MaintenanceAccidentsQueries()
